import React, { useRef, useState } from 'react';
import { Modal } from 'antd';
import Draggable from 'react-draggable';
import { stylesDuPanneau } from './elevationModale';

/**
 * Modal SDI - drop-in remplacement d'AntD `Modal`.
 *
 *  - Déplaçable à la souris depuis la barre de titre.
 *  - Fond non-dimmé (`mask={false}`) pour laisser l'utilisateur interagir derrière.
 *  - Compatible toutes les props standard d'AntD `Modal`.
 *
 * Compatible `Modal.confirm/info/warning/error` : on ré-expose les méthodes statiques.
 */
const CBModal = ({
  title, children, modalRender, mask = false, maskClosable = false, styles, ...rest
}) => {
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 });
  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef(null);

  const onStart = (_, uiData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) return;
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  const draggableTitle = (
    <div
      style={{ width: '100%', cursor: disabled ? 'move' : 'move', userSelect: 'none' }}
      onMouseOver={() => disabled && setDisabled(false)}
      onMouseOut={() => setDisabled(true)}
      onFocus={() => { }}
      onBlur={() => { }}
    >
      {title}
    </div>
  );

  return (
    <Modal
      {...rest}
      /* DEUX DÉFAUTS FERMÉS ICI, voir `elevationModale.js`.

         LE CORPS DÉFILE. Sans hauteur maximale, un modal plus haut que l'écran
         poussait ses boutons sous la ligne de flottaison - et comme le fond
         n'est pas assombri ni scrollable, ils devenaient inatteignables : on
         voyait le formulaire sans pouvoir l'enregistrer.

         LE PANNEAU SE VOIT. `mask={false}` laissait le panneau se confondre avec
         le contenu qu'il recouvre : rien ne disait qu'il flottait. Un voile peint
         par une ombre à très grand étalement l'en détache, sans poser de calque -
         donc sans reprendre la frappe derrière, qui est la raison d'être de
         `mask={false}`.

         Posé ici et non dans chaque modal : les deux défauts se reproduiraient au
         premier formulaire venu, et personne ne penserait à les prévenir. Les
         styles de l'appelant restent prioritaires. */
      styles={stylesDuPanneau(styles)}
      mask={mask}
      maskClosable={maskClosable}
      title={draggableTitle}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={bounds}
          nodeRef={draggleRef}
          onStart={onStart}
          handle=".ant-modal-header"
        >
          <div ref={draggleRef}>{modalRender ? modalRender(modal) : modal}</div>
        </Draggable>
      )}
    >
      {children}
    </Modal>
  );
};

// Ré-expose les méthodes statiques AntD pour compatibilité
CBModal.confirm = Modal.confirm;
CBModal.info = Modal.info;
CBModal.success = Modal.success;
CBModal.warning = Modal.warning;
CBModal.error = Modal.error;
CBModal.destroyAll = Modal.destroyAll;

export default CBModal;
